import moment from 'moment';

const MESSENGER_DATE_FORMAT = "YYYY-MM-DD";

export const getFormattedDate = dateTime => moment(dateTime).format(MESSENGER_DATE_FORMAT);
